<template>
  <div class="unverified">
    <van-cell class="actValue" title="邀约访客">
      <span>
        <router-link :to="'home'">来访预约</router-link>
      </span>
    </van-cell>
    <div class="wrap">
      <svg-icon icon-class="err" />
      <p>只有认证员工才能邀约访客哦！</p>
    </div>

    <van-button class="sub_btn" type="info" @click="handleVerify">我是员工，立即认证</van-button>
  </div>
</template>

<script>

import { searchStaff } from '@/api/home'
import { GetUserInfo } from '@/api/user'
export default {
  name: 'Unverified',

  data() {
    return {
      userInfo: {} // 用户信息，用于邀约访客判断是否已认证为员工
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    getUserInfo() {
      const data = {}
      GetUserInfo(data).then(res => {
        res.data ? this.userInfo = res.data : this.$router.push({ name: 'bind' })
      })
    },
    handleVerify() {
      const data = {
        phone: this.userInfo.phone
      }
      searchStaff(data).then(res => {
        if (res.code === 200) {
          sessionStorage.setItem('staffInfo', JSON.stringify(res.data))
          this.$router.push({ name: 'match' })
        } else {
          this.$router.push({ name: 'unmatch' })
        }
      })
    }
  }

}
</script>

<style lang="less">
.unverified {
  .actValue {
    .van-cell__value {
      color: #3b86ff;
      a {
        color: #3b86ff;
      }
    }
  }
  .svg-icon {
    font-size: 0.6rem;
    margin-bottom: 0.2rem;
  }
  .wrap {
    text-align: center;
    margin-top: 1.3rem;
    font-size: 0.14rem;
    color: #333;
  }
}
</style>
